<template>
  <div class="forumListContainer">
    <div class="forumItemContainer" v-if="forum" key="forum">
      <div class="avatarContainer">
        <el-image
          class="avatar"
          fit="cover"
          :src="forum.user.avatar"
          @click="goHomePage(forum.user.id)"
        >
        </el-image>
        <div class="name_time">
          <div
            class="display_name one_lines"
            @click="goHomePage(forum.user.id)"
          >
            <span>
              {{ forum.user.display_name }}
            </span>

            <span v-if="forum.tenant" key="tenant" class="tenant">
              （{{ forum.tenant.name }}）
            </span>
          </div>
          <div class="created_time">
            {{ forum.created_time.slice(5, 16) }}
          </div>
        </div>
      </div>
      <div class="contentContainer">
        <span
          class="tag"
          @click="
            $router.push({ name: 'forum', query: { tag_id: forum.tag_id } })
          "
        >
          #{{
            l($utils.listFilter(
              $store.state.basicInfo.tagList.forum,
              forum.tag_id
            ))
          }}#
        </span>
        {{ forum.content }}
      </div>
      <div class="img_arrayContainer" v-if="forum.img_array.length">
        <el-image
          v-for="item of forum.img_array"
          :key="item"
          fit="cover"
          :src="item"
          :preview-src-list="forum.img_array"
        >
        </el-image>
      </div>

      <div class="operationContainer">
        <el-dropdown trigger="click" @command="handleCommand">
          <i class="el-icon-more"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-if="forum.user.id != $store.state.session.user.id"
              icon="el-icon-warning-outline"
              command="accusationItem"
              >{{l("举报")}}</el-dropdown-item
            >
            <el-dropdown-item
              v-if="forum.user.id == $store.state.session.user.id"
              icon="el-icon-edit"
              command="editItem"
              >{{l("编辑")}}</el-dropdown-item
            >
            <el-dropdown-item
              v-if="forum.user.id == $store.state.session.user.id"
              icon="el-icon-delete"
              command="offItem"
              >{{l("删除")}}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <div class="commentPublishContainer">
      <ForumPublish
        mode="comment"
        :target="forum"
        @submitDialog="getDiscussList"
      />
    </div>
    <div class="discussListContainer">
      <ForumComment
        v-for="item of discussList"
        :key="item.mode + item.id"
        :mode="item.mode"
        :detail="item"
        @click_reply="handleShowDialog"
        @refresh_list="getDiscussList"
      />
    </div>

    <el-dialog
      v-if="showDialog"
      width="720px"
      :title="l('回复') + '@' + dialogTarget.user.display_name"
      :visible.sync="showDialog"
      :destroy-on-close="true"
    >
      <ForumPublish
        mode="reply"
        :target="dialogTarget"
        @submitDialog="
          showDialog = false;
          getDiscussList();
        "
      />
    </el-dialog>

    <el-dialog
      v-if="showEditDialog"
      width="720px"
      :title="l('编辑帖子')"
      :visible.sync="showEditDialog"
      :destroy-on-close="true"
    >
      <ForumPublish
        mode="forum"
        :target_4_edit="target_4_edit"
        @submitDialog="
          showEditDialog = false;
          getForumDetail();
        "
      />
    </el-dialog>
  </div>
</template>

<script>
import ForumPublish from "./ForumPublish.vue";
import ForumComment from "./ForumComment.vue";

export default {
  name: "HomeForumDetail",
  components: { ForumPublish, ForumComment },
  data() {
    return {
      forum: null,
      discussList: [],

      showDialog: false,
      dialogTarget: {},

      showEditDialog: false,
      target_4_edit: {},
    };
  },
  created() {
    this.getForumDetail();
    this.getDiscussList();
  },
  mounted() {},
  methods: {
    getForumDetail() {
      this.axios
        .get(`/api/visitor_forum/${this.$route.params.id}/`)
        .then((data) => {
          data.img_array = JSON.parse(data.img_array);
          this.forum = data;
        });
    },
    getDiscussList() {
      this.axios
        .get(`/api/visitor_forum/${this.$route.params.id}/discuss_list/`)
        .then((data) => {
          data.results.forEach((item) => {
            item.mode = "comment";
            item.reply_list.forEach((reply) => {
              reply.mode = "reply";
            });
          });
          for (let i = 0; i < data.results.length; i++) {
            if (data.results[i].mode == "comment") {
              data.results.splice(i + 1, 0, ...data.results[i].reply_list);
            }
          }
          this.discussList = data.results;
        });
    },
    clickPraise(forum) {},
    handleShowDialog(target) {
      this.dialogTarget = this._.cloneDeep(target);
      console.log("this.dialogTarget", this.dialogTarget);
      this.showDialog = true;
    },
    handleCommand(command) {
      this[command]();
    },
    accusationItem() {
      console.log(this.forum);
      this.$prompt(this.l("请填写举报原因"), this.l("举报"), {
        confirmButtonText: this.l("确定"),
        cancelButtonText: this.l("取消"),
        inputPattern: /\S/,
        inputErrorMessage: this.l("请填写举报原因"),
      }).then(({ value }) => {
        this.axios.post(`/api/user_accusation/`, {
          record_sign: this.forum.id,
          module: "accusation",
          comment: this.l("举报论坛贴子") + "：" + value,

        });
      });
    },
    editItem() {
      this.target_4_edit = {
        id: this.forum.id,
        tag_id: this.forum.tag_id,
        content: this.forum.content,
        img_array: this.forum.img_array,
      };
      this.showEditDialog = true;
    },
    offItem() {
      this.$confirm(this.l("是否确认删除") + "？", "", {
        type: "warning",
      }).then(() => {
        this.axios.put(`/api/forum/my_post/${this.forum.id}/off/`).then(() => {
          this.$router.push("/home/forum");
        });
      });
    },
    goHomePage(user_id) {
      if (!user_id) return;
      this.$router.push("/home/forum/?tab=post&user_id=" + user_id);
    },
  },
};
</script>


<style scoped lang="scss">
.forumListContainer {
  .forumItemContainer {
    background: #fff;
    padding: 20px;
    margin-top: 10px;
    box-sizing: border-box;
    position: relative;
    &:first-child {
      margin-top: 0;
    }
    .avatarContainer {
      display: flex;
      position: relative;
      .avatar {
        width: 42px;
        height: 42px;
        cursor: pointer;
      }
      .name_time {
        margin-left: 15px;
        .display_name {
          font-weight: bold;
          max-width: 600px;
          cursor: pointer;
          .tenant {
            font-weight: normal;
            color: #666;
          }
        }
        .created_time {
          color: #999;
          font-size: 12px;
          margin-top: 6px;
        }
      }
    }
    .contentContainer {
      margin-top: 12px;
      margin-left: 57px;
      line-height: 18px;
      .tag {
        color: $warningColor;
        cursor: pointer;
      }
      .overflow_btn {
        padding-left: 10px;
        color: $warningColor;
        cursor: pointer;
      }
    }
    .img_arrayContainer {
      margin-top: 12px;
      margin-left: 57px;
      display: flex;
      flex-wrap: wrap;
      .el-image {
        width: 208px;
        height: 155px;
        border-radius: 6px;
        margin-left: 8px;
        &:nth-child(3n + 1) {
          margin-left: 0;
        }
        &:nth-child(n + 4) {
          margin-top: 8px;
        }
      }
    }

    .operationContainer {
      position: absolute;
      top: 22px;
      right: 22px;
      i {
        font-size: 16px;
        cursor: pointer;
      }
    }
  }
}

.commentPublishContainer {
  padding: 20px;
  border-top: 1px solid $borderPlainColor;
  background: #fff;
}
.discussListContainer {
  padding: 20px;
  border-top: 1px solid $borderPlainColor;
  background: #fff;
}
</style>

